import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { editContentAction } from 'reducks/modal/actions'

const editContentInModal = () => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const edited = getState().modal.edited
    if (edited) return
    dispatch(editContentAction())
  }
}

export default editContentInModal
